import { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppContext } from 'contexts/AppProvider'
import { useLocation, useHistory } from 'react-router-dom'
import { buffetSelector, setMemberCoupons } from 'store/slices/buffetSlice'
import useFpmemberCoupons from 'hooks/dine-in/useFpmemberCoupons'
import useSearchParams from 'hooks/useSearchParams'
import useShareCoupon, { ValidateResult } from 'hooks/dine-in/useShareCoupon'
import { SubPageName } from 'enums/buffet'
import { convertListFPMemberCouponsToCoupons } from 'helpers/coupon'

const useActionParamShareCoupon = () => {
  const buffet = useSelector(buffetSelector)
  const { currentMembership, currentUser } = useContext(AppContext)
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const { params } = useSearchParams()
  const { listFpMemberCouponsLazyQuery } = useFpmemberCoupons({
    orderID: buffet.table.orderID,
    userIDs: [currentUser.id],
    currentMembershipId: Number(currentMembership?.id),
  })
  const {
    validateShareCoupon,
    handleInvalidShareCoupon,
    modalNoneMembership,
    modalLimitSharingCoupons,
    modalEmptyCoupons,
  } = useShareCoupon({
    totalUserSharedCoupons: buffet.totalUsersSharedCoupons,
  })
  const hasActionShareCoupon = params.get('action') === 'share-coupon'

  const handleInvalid = (validationResult: ValidateResult) => {
    handleInvalidShareCoupon({
      validationResult,
      goToShareCouponPage: () => history.push(SubPageName.ShareCoupon),
    })
  }

  const handleActionParam = async (_allowedSharingCoupon: boolean) => {
    if (hasActionShareCoupon) {
      params.delete('action')
      const pathWithoutAction = `${location.pathname}?${params.toString()}`
      const validationResult = validateShareCoupon(_allowedSharingCoupon)
      if (!validationResult.pass) {
        history.replace(pathWithoutAction)
        handleInvalid(validationResult)
        return
      }

      await listFpMemberCouponsLazyQuery({
        onCompleted: ({ listFPMemberCoupons }) => {
          const fpCoupons = convertListFPMemberCouponsToCoupons({
            listFPMemberCoupons,
            currentMembershipId: currentMembership?.id,
            allowedSharingCoupon: buffet.allowedSharingCoupon,
          })
          dispatch(setMemberCoupons(fpCoupons))
          history.replace(pathWithoutAction)
          if (fpCoupons.length === 0) {
            modalEmptyCoupons.setOpen(true)
          } else {
            history.push(SubPageName.ConfirmShareCoupon)
          }
        },
      })
    }
  }

  return { modalNoneMembership, modalLimitSharingCoupons, modalEmptyCoupons, handleActionParam, hasActionShareCoupon }
}

export default useActionParamShareCoupon
